var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsGrid06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 5.50065C12.9602 5.50065 13.3333 5.12755 13.3333 4.66732C13.3333 4.20708 12.9602 3.83398 12.4999 3.83398C12.0397 3.83398 11.6666 4.20708 11.6666 4.66732C11.6666 5.12755 12.0397 5.50065 12.4999 5.50065Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 11.334C12.9602 11.334 13.3333 10.9609 13.3333 10.5007C13.3333 10.0404 12.9602 9.66732 12.4999 9.66732C12.0397 9.66732 11.6666 10.0404 11.6666 10.5007C11.6666 10.9609 12.0397 11.334 12.4999 11.334Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 17.1673C12.9602 17.1673 13.3333 16.7942 13.3333 16.334C13.3333 15.8737 12.9602 15.5007 12.4999 15.5007C12.0397 15.5007 11.6666 15.8737 11.6666 16.334C11.6666 16.7942 12.0397 17.1673 12.4999 17.1673Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 5.50065C7.12682 5.50065 7.49992 5.12755 7.49992 4.66732C7.49992 4.20708 7.12682 3.83398 6.66659 3.83398C6.20635 3.83398 5.83325 4.20708 5.83325 4.66732C5.83325 5.12755 6.20635 5.50065 6.66659 5.50065Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 11.334C7.12682 11.334 7.49992 10.9609 7.49992 10.5007C7.49992 10.0404 7.12682 9.66732 6.66659 9.66732C6.20635 9.66732 5.83325 10.0404 5.83325 10.5007C5.83325 10.9609 6.20635 11.334 6.66659 11.334Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 17.1673C7.12682 17.1673 7.49992 16.7942 7.49992 16.334C7.49992 15.8737 7.12682 15.5007 6.66659 15.5007C6.20635 15.5007 5.83325 15.8737 5.83325 16.334C5.83325 16.7942 6.20635 17.1673 6.66659 17.1673Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGrid06);
export default __webpack_public_path__ + "static/media/dots-grid-06.251e668676e15b70ebe980cea7af65e2.svg";
export { ForwardRef as ReactComponent };